/* Wagbowl — Add to bag → cart drawer. ONE OWNER for "add a variant and open the drawer".
   Lifted from sections/wb-pdp-buybox (2026-10-09 flow) so a second surface (sections/wb-recipe-rooms) does not carry a
   copy. TODO (logged in State D3): point wb-pdp-buybox at this file too and delete its inline copy.

   Progressive: no drawer element, no fetch, or ANY error falls back to the plain form POST to /cart/add — so a failure
   can only ever be the old behaviour. The drawer is looked up at TAP time: cart-drawer.js is deferred and usually
   defines the element after a section's script runs.

   window.WBAddToBag(form, buttons)  — form posts id + quantity to routes.cart_add_url; buttons get aria-busy.

   window.WBAddToBag.quiet(op, id, qty) — 15 Oct 2026, the recipe rooms (Add → arc into the bag → − n + stepper).
     op 'add': id = variant id, qty to add.  op 'change': id = the line key (or variant id), qty = the new quantity.
     Updates the bag count AND the drawer's contents (so the drawer is right when opened) WITHOUT opening it.
     Returns a Promise of Shopify's JSON (add: {items}, change: the cart); rejects on any error so the caller can fall
     back to a plain form POST. */
(function () {
  if (window.WBAddToBag) return;
  window.WBAddToBag = function (form, buttons) {
    if (!form || form.dataset.wbBag || !window.fetch || !window.FormData) return;
    form.dataset.wbBag = '1';
    buttons = (buttons || []).filter(Boolean);
    form.addEventListener('submit', function (e) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function') return;          // plain POST, as before
      e.preventDefault();
      buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
      var fd = new FormData(form);
      var secs = drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-drawer', 'cart-icon-bubble'];
      fd.append('sections', secs.join(','));
      fd.append('sections_url', window.location.pathname);
      function done() { buttons.forEach(function (b) { b.removeAttribute('aria-busy'); b.disabled = false; }); }
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
        body: fd
      }).then(function (r) { return r.json(); }).then(function (res) {
        done();
        if (res.status || !res.sections) { form.submit(); return; }                 // e.g. sold out: Shopify's own page explains it
        var inner = drawer.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
      }).catch(function () { done(); form.submit(); });
    });
  };

  function paint(sections, empty) {
    if (!sections) return;
    var drawer = document.querySelector('cart-drawer');
    var list = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender() : [{ id: 'cart-icon-bubble' }];
    list.forEach(function (sec) {
      var html = sections[sec.id]; if (!html) return;
      var el = sec.selector ? document.querySelector(sec.selector) : document.getElementById(sec.id); if (!el) return;
      if (drawer && drawer.getSectionInnerHTML) { el.innerHTML = drawer.getSectionInnerHTML(html, sec.selector); return; }
      var doc = new DOMParser().parseFromString(html, 'text/html'), src = doc.querySelector(sec.selector || '.shopify-section');
      if (src) el.innerHTML = src.innerHTML;
    });
    if (drawer) {
      var inner = drawer.querySelector('.drawer__inner');
      if (inner) inner.classList.toggle('is-empty', !!empty);
      drawer.classList.toggle('is-empty', !!empty);
    }
  }
  window.WBAddToBag.quiet = function (op, id, qty) {
    if (!window.fetch) return Promise.reject(new Error('no fetch'));
    var drawer = document.querySelector('cart-drawer');
    var secs = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-icon-bubble'];
    var r = window.routes || {};
    var url = op === 'add' ? (r.cart_add_url || '/cart/add') + '.js' : (r.cart_change_url || '/cart/change') + '.js';
    var body = op === 'add'
      ? { items: [{ id: Number(id), quantity: qty || 1 }], sections: secs.join(','), sections_url: window.location.pathname }
      : { id: String(id), quantity: qty, sections: secs.join(','), sections_url: window.location.pathname };
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        if ((json.status && json.status >= 400) || (json.errors && !json.items)) throw json;
        paint(json.sections, op !== 'add' && json.item_count === 0);
        return json;
      });
  };
})();
